import React, { useCallback, useEffect, useState } from 'react'
import { Button, Card, CardContent, Grid, Paper, TextField } from '@material-ui/core'
import { Page, Header } from 'components'
import { forwardRef } from 'react'
import moment from 'moment'
import localization from 'moment/locale/pt-br'
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward'
import SearchIcon from '@material-ui/icons/Search'
import ClearIcon from '@material-ui/icons/Clear'
import NavigateNextIcon from '@material-ui/icons/NavigateNext'
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore'
import FirstPageIcon from '@material-ui/icons/FirstPage'
import LastPageIcon from '@material-ui/icons/LastPage'
import useRouter from 'utils/useRouter'
import { useAuth } from 'hooks/useAuth'
import AutocompleteNative from '@material-ui/lab/Autocomplete'
import { useSolicitacaoExameService } from 'hooks/useSolicitacaoExameService'
import useStyles from './styles'
import MaterialTable from 'material-table'

export const ListaSolicitacoes = (props) => {
  moment.locale('pt-br', localization)
  const { route } = props
  const classes = useStyles()
  const solicitacaoExameService = useSolicitacaoExameService()
  const router = useRouter()
  const { currentUser } = useAuth()
  const [setor, setSetor] = useState(null)
  const [solicitacoes, setSolicitacoes] = useState([])
  const [processando, setProcessando] = useState(false)

  const fetchSolicitacoes = useCallback(async () => {
    if (setor) {
      setProcessando(true)
      const response = await solicitacaoExameService.listarSolicitacoesRealizadasPeloSetor(setor.id)
      setSolicitacoes(response)
      setProcessando(false)
    }
  }, [setor])

  useEffect(() => {
    fetchSolicitacoes()
  }, [fetchSolicitacoes])

  return (
    <Page className={classes.root} title={`${route.titulo} - SIGEP`}>
      <Header titulo={route.titulo} overline={route.secao} />
      <Card className={classes.results}>
        <CardContent>
          <>
            <AutocompleteNative
              value={setor}
              name="setor"
              noOptionsText="Sem informações"
              options={currentUser.setores}
              onChange={(event, newValue) => {
                setSetor(newValue)
              }}
              getOptionLabel={(option) => `${option.nome.toUpperCase()} / ${option.divisao.sigla.toUpperCase()} / ${option.divisao.regional.nome.toUpperCase()} / ${option.divisao.regional.orgao.sigla.toUpperCase()}`}
              className={classes.selectSetor}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Selecione o setor..."
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              )}
            />
            {setor && (
              <div className={classes.menuSuperior}>
                <MaterialTable
                  components={{ Container: (props) => <Paper {...props} elevation={0} /> }}
                  localization={{
                    pagination: {
                      labelDisplayedRows: '{from}-{to} de {count}',
                      labelRowsSelect: 'linhas',
                      nextTooltip: 'Página seguinte',
                      previousTooltip: 'Página anterior',
                      lastTooltip: 'Última página',
                      firstTooltip: 'Primeira página',
                    },
                    toolbar: {
                      nRowsSelected: '{0} linha(s) selecionadas',
                      searchPlaceholder: 'Buscar',
                    },
                    header: {
                      actions: 'Ações',
                    },
                    body: {
                      emptyDataSourceMessage: 'Nada para mostrar',
                      filterRow: {
                        filterTooltip: 'Filtro',
                      },
                    },
                  }}
                  columns={[
                    {
                      title: 'Número da solicitação',
                      render: (rowData) => rowData.identificador,
                    },
                    {
                      title: 'Setor responsável',
                      render: (rowData) => `${rowData.setReq.nome.toUpperCase()} / ${rowData.setReq.divisao.sigla.toUpperCase()} / ${rowData.setReq.divisao.regional.sigla.toUpperCase()}`,
                    },
                    {
                      title: 'Data',
                      render: (rowData) => moment(rowData.updatedAt).format('LLLL'),
                    },
                  ]}
                  onRowClick={(event, rowData, togglePanel) => {
                    router.history.push(`/solicitacaoexame/fichasolicitacaoexame/detalhar/${rowData.id}`)
                  }}
                  title=""
                  data={solicitacoes}
                  options={{
                    actionsColumnIndex: -1,
                    search: true,
                    pageSize: 10,
                    searchFieldStyle: {
                      flexGrow: 1,
                      height: 42,
                      // padding: theme.spacing(0, 2),
                      display: 'flex',
                      alignItems: 'center',
                    },
                    headerStyle: {
                      backgroundColor: '#f4f6f8',
                    },
                  }}
                  style={{
                    padding: '0',
                    margin: '0',
                    fontSize: '13px',
                    textAlign: 'left',
                    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
                    fontWeight: '400',
                    lineHeight: '21px',
                    borderBottom: '1px solid #eeeeee',
                    letterSpacing: '-0.05px',
                    verticalAlign: 'inherit',
                  }}
                  icons={{
                    SortArrow: forwardRef((propsSortArrow, ref) => <ArrowDownwardIcon {...propsSortArrow} ref={ref} />),
                    Search: forwardRef((propsSearch, ref) => <SearchIcon {...propsSearch} ref={ref} />),
                    ResetSearch: forwardRef((propsResetSearch, ref) => <ClearIcon {...propsResetSearch} ref={ref} />),
                    NextPage: forwardRef((propsNextPage, ref) => <NavigateNextIcon {...propsNextPage} ref={ref} />),
                    DetailPanel: forwardRef((propsNextPage, ref) => <NavigateNextIcon {...propsNextPage} ref={ref} />),
                    PreviousPage: forwardRef((propsPreviousPage, ref) => <NavigateBeforeIcon {...propsPreviousPage} ref={ref} />),
                    FirstPage: forwardRef((propsFirstPage, ref) => <FirstPageIcon {...propsFirstPage} ref={ref} />),
                    LastPage: forwardRef((propsLastPage, ref) => <LastPageIcon {...propsLastPage} ref={ref} />),
                  }}
                />
              </div>
            )}
          </>
        </CardContent>
      </Card>
    </Page>
  )
}
